<template>
  <asc-dialog
    text="Global Filter"
    primary-button-text="Apply"
    :show-dialog="showDialog"
    :on-close="handleCloseDialog"
    :on-primary="handleAccept"
    :primary-available="isCurrentDataValid && !isGfApplyButtonDisabled"
    secondary-button-text="Reset Filter"
    :on-secondary="handleSecondary"
    :width="900"
  >
    <template v-if="showDialog">
      <asc-global-filter
        v-model="currentData"
        :reset-data="resetData"
        :airlines-with-master-models="airlinesWithMasterModels"
        :master-models-with-airlines="masterModelsWithAirlines"
      ></asc-global-filter>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscGlobalFilter from './AscGlobalFilter'
import isEqual from 'lodash/isEqual'

export default {
  name: 'AscGlobalFliterDialog',

  components: {
    AscDialog,
    AscGlobalFilter,
  },

  mixins: [AscDialogMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    airlinesWithMasterModels: {
      type: Array,
      default: () => [],
    },
    masterModelsWithAirlines: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentData: this.data,
      savedData: this.data,
      resetData: this.data,
    }
  },

  computed: {
    isGfApplyButtonDisabled() {
      return (
        isEqual(this.currentData, this.savedData) &&
        isEqual(this.savedData, this.resetData)
      )
    },
    isCurrentDataValid() {
      if (this.currentData) {
        const selections = this.currentData.selections || []
        const allSelected = this.currentData.allSelected
        return selections.length > 0 || allSelected
      }

      return false
    },
  },

  watch: {
    data: {
      deep: true,
      handler(gf) {
        this.currentData = gf
        this.resetData = gf
      },
    },
  },

  methods: {
    handleAccept() {
      this.savedData = this.currentData
      this.onAccept(this.currentData)
      this.handleClose()
    },

    handleCloseDialog() {
      this.currentData = this.savedData
      this.handleClose()
    },

    handleSecondary() {
      this.currentData = {
        allSelected: true,
        isActive: true,
        selections: [],
        checkedOption: 'filterByAirline',
      }
    },
  },
}
</script>
